import React from "react";
import { useState, useEffect } from "react";
// all css comes in publishedQListPreRead
import PdfQType from "../../Published/Published_Q_list/PublishQuestionType/PdfType/PdfQType";
import axios from "../../../../../axios";
import { Link, NavLink, useLocation } from "react-router-dom";

import moment from "moment";

export default function ScheduleQListPreRead() {
  //Added this state by kuldeep
  const { state } = useLocation()

  const [prescheduleData, setpreScheduleData] = useState({
    schedulePreRead: [],
  });
  const { schedulePreRead } = prescheduleData;

  useEffect(() => {
    const getSchedulePreRead = async () => {
      try {
        const res = await axios.get(
          `/api/v1/homework/preRead/getById/${state.schedulePre_id}`
        );
        res &&
          setpreScheduleData({
            schedulePreRead: res.data.data,
          });
      } catch (error) { }
    };
    getSchedulePreRead();
  }, []);

  return schedulePreRead ? (
    <>
      <div>
        <div className="d-flex align-items-center ">
          <Link to="/PublishedHomeworkPreRead">
            <img src="/images/Back Arrow.svg" alt=""></img>
          </Link>
          <Link to="/PublishedHomeworkPreRead" className="link">
            <span className="open_publish_path_pre">
              &nbsp; Scheduled /&nbsp;
            </span>
          </Link>
          <span className="open_publish_path1_pre">
            {schedulePreRead?.name}
          </span>
        </div>
        <div className="mt-4 publishsub_heading_pre">
          {schedulePreRead?.name}
        </div>
        <div className=" d-flex align-items-center justify-content-between ">
          <div className=" d-flex align-items-center justify-content-center ">
            <span className="subject_prereads">
              {schedulePreRead?.subject_id?.name} &nbsp;
            </span>
            <span className=" open_ststus_preread ">
              Scheduled
            </span>
            <span className="subject_prereads">
              &nbsp;
              {moment(schedulePreRead?.schedule_date).calendar(null, {
                sameDay: "[Today]",
                nextDay: "[Tomorrow]",
                nextWeek: "DD/MM/YYYY",
                lastDay: "DD/MM/YYYY",
                lastWeek: "DD/MM/YYYY",
                sameElse: "DD/MM/YYYY",
              })}
              &nbsp; | &nbsp;
              {moment(schedulePreRead?.schedule_time).format("h:mm A")}
            </span>
          </div>

          <NavLink to={`/ScheduleEdit_PreReads`} state={{ schedulePre_id: state.schedulePre_id }}>
            <button className="Edit_Btn me-3 " type="button">
              Edit
            </button>
          </NavLink>
        </div>
        <div className="Published_PR_text mt-4 mb-3">
          {schedulePreRead?.description}
        </div>

        <div className="mt-4 d-flex pdf_container_prepread">
          {schedulePreRead?.attachments?.length !== 0 &&
            schedulePreRead?.attachments?.map((attachment) => (
              <PdfQType attachData={schedulePreRead} attachment={attachment} />
            ))}
        </div>
        <div className="me-4 btn_draft_pre mt-5">
          <Link to="/PublishedHomeworkPreRead">
            <button className="btn  m-1 py-2 pre_publish_close_button">Close</button>
          </Link>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
}
